import React        from 'react';
import {
    SearchInput,
}                   from '../../../uikit/dropdown/components'; 

class ListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            scrollTop   : this.props.scrollTop,
            fromClient  : false,
        };
    }

    componentDidMount() {
        this.setState({
            fromClient: true,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.scrollTop !== prevProps.scrollTop) {
            this.setState({ scrollTop: this.props.scrollTop }, () => {
                this.setState({ scrollTop: undefined })
            })
        }
    }

    createComponentClasses() {
        let {
            className,
            isOpened,
            isSearchable
        } = this.props;

        let classNames = ['simprakit-dropdown-list-container'];
        if (isOpened)                  classNames.push('opened');
        if (isSearchable)              classNames.push('searchable');
        if (className)                 Array.prototype.push.apply(classNames, className.split(' '));

        return [...new Set(classNames)].join(' ');
    }

    render(){
        let p = this.props;
        let s = this.state;
        return(
            <div ref="CONTAINER" className={ this.createComponentClasses() }>
                {
                    p.isSearchable
                        ?   <SearchInput
                                value       = { p.searchValue }
                                onSearch    = { keyword => p.onSearch(keyword) }
                            />
                        :   null
                }
                <ul style={{ height: s.fromClient && p.optionCount > 0 ? (p.optionCount * 47) - 1 : 0 }}>
                        { p.children }
                </ul>
            </div>
        )
    }
}

export default ListContainer;